var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyramidGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 135,
    viewBox: "0 0 156 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pyramid-graphic",
    transform: "translate(16599 7865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M23.111,95,0,135H156L132.888,95Z",
    transform: "translate(-16599 -7865)",
    fill: "#9879a5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M131.733,93H24.267L47.378,53h61.244l23.11,40Z",
    transform: "translate(-16599 -7865)",
    fill: "#ef956e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M78,0,48.533,51h58.934Z",
    transform: "translate(-16599 -7865)",
    fill: "#bad7a2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Preferences",
    transform: "translate(-16521 -7821)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "Preferences")), /*#__PURE__*/React.createElement("text", {
    id: "Behaviors_and_Actions",
    "data-name": "Behaviors and Actions",
    transform: "translate(-16558 -7796)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 8
  }, "Behaviors and Actions")), /*#__PURE__*/React.createElement("text", {
    id: "Environmental_and_Situation",
    "data-name": "Environmental and Situation",
    transform: "translate(-16521 -7747)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46,
    y: 0
  }, "Environmental and Situation")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramidGraphic);
export default __webpack_public_path__ + "static/media/pyramid-graphic.771af891ca5454a884cd3bf10bd765d8.svg";
export { ForwardRef as ReactComponent };